import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '追跡管理',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
  staffOnly: true,
  listed: false,
};
